import React, { useEffect } from "react";
import {
  Box,
  Breadcrumbs,
  Container,
  Link as MLink,
  Typography,
  IconButton,
} from "@mui/material";
import { ArrowBack as ArrowBackIcon, ChevronRight } from "@mui/icons-material";
import { Link, useParams, useLocation, useNavigate } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import apiService, { Podcast } from "../services/api";
import PodcastInvitations from "../components/PodcastInvitations";
import { useAuth } from "../contexts/AuthContext";
import { miContenidoMediaKitDetailPath } from "../miContenido/paths";

const SettingsPodcastInvitations: React.FC = () => {
  const { user } = useAuth();
  const navigate = useNavigate();
  const { slug: rawSlug } = useParams<{ slug: string }>();
  const slug = rawSlug ? decodeURIComponent(rawSlug) : undefined;
  const location = useLocation();
  const {
    data: podcast,
    isLoading,
    error,
  } = useQuery({
    queryKey: ["settings-podcast-by-slug", slug],
    queryFn: () => apiService.getPodcastBySlug(slug || ""),
    enabled: !!slug,
  });
  const { data: myCompany } = useQuery({
    queryKey: ["settings-my-company", user?.companyId],
    queryFn: () => apiService.getMyCompany(),
    enabled: !!user?.companyId,
  });

  /** Media kit config moved to Mi contenido; keep old `#media-kit` links working. */
  useEffect(() => {
    if (location.hash !== "#media-kit" || !podcast?._id) return;
    navigate(miContenidoMediaKitDetailPath(String(podcast._id)), {
      replace: true,
    });
  }, [location.hash, podcast?._id, navigate]);

  return (
    <Container maxWidth="xl">
      <Box className="flex items-center gap-3">
        <IconButton
          component={Link}
          to="/settings"
          aria-label="Volver"
          title="Volver"
        >
          <ArrowBackIcon color="primary" fontSize="medium" />
        </IconButton>
        <Breadcrumbs
          aria-label="breadcrumb"
          separator={
            <ChevronRight
              color="primary"
              fontSize="medium"
              sx={{ display: { xs: "none", sm: "block" } }}
            />
          }
          sx={{
            typography: "h1",
            "& .MuiBreadcrumbs-separator": {
              display: { xs: "none", sm: "block" },
            },
          }}
        >
          <MLink
            component={Link}
            to="/settings"
            underline="hover"
            color="inherit"
            sx={{ typography: "h1", display: { xs: "none", sm: "block" } }}
          >
            Configuraciones
          </MLink>
          <Typography variant="h1" color="text.primary">
            {podcast?.title || "Podcast"}
          </Typography>
        </Breadcrumbs>
      </Box>

      <Box sx={{ py: 4 }}>
        {isLoading ? (
          <Typography>Cargando…</Typography>
        ) : error || !podcast ? (
          <Typography color="error">No se pudo cargar el podcast</Typography>
        ) : (
          <PodcastInvitations
            podcast={podcast as Podcast}
            companyId={(myCompany as any)?._id}
            companySlug={myCompany?.slug || ""}
          />
        )}
      </Box>
    </Container>
  );
};

export default SettingsPodcastInvitations;
